<template lang="html">
  <div class="ebooks">
    <section class="middle-intro row-start">
      <div class="container">
        <h1 class="title -intro">{{ $t("menu.ebooks") }}</h1>
        <img src="/static/img/gifs/ebooks.gif" class="imagen-animacion" alt="ebooks"/>
      </div>
    </section>
    <div class="container">
      <section class="tool-search">
        <input
          type="text"
          :placeholder="$t('blog.buscar')"
          id="searchTool"
          v-model="textSearch"
          @keyup.enter="search"
        />
        <button @click="search" class="btn-search fa fa-search"></button>
      </section>
    </div>

    <section class="container">
      <div class="list-ebooks">
        <section
          class="ebook-el"
          @click="togglePopUp(ebook.title, ebook.dataId)"
          v-for="(ebook, key) in ebooks"
        >
          <ebook-el
            :idEbook="ebook.dataId"
            :attached="ebook.attached"
            :nameEbook="ebook.title"
            :imgUrl="ebook.image.url"
            :descriptionEbook="ebook.description"
          ></ebook-el>
        </section>
      </div>
      <div class="popup-form" :class="[show_form ? 'open-pop-up' : '']">
        <div class="form-ebook">
          <span @click="closePopup" class="btnClose"></span>
          <p class="title">
             <template v-if="ebook_descargado">Lo sentimos </template>
            {{ nameEbookPopup }}
            <template v-if="form_enviado">se descargó correctamente.</template>
            <template v-if="ebook_descargado">ya fue descargado con este email.</template>
          </p>

          <template v-if="!form_enviado && !ebook_descargado">
            <form id="formEbook" @submit.prevent="validateBeforeSubmit">
              <div class="contenedor-input">
                <label for="name">Nombre y Apellidos</label>
                <input
                  type="text"
                  class="input-text"
                  v-validate="'required'"
                  name="name"
                  v-model="data.name"
                  placeholder="Nombre y Apellidos"
                />
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("name") }}</span
                >
              </div>
              <div class="contenedor-input">
                <label for="job_title">Cargo</label>
                <input
                  type="text"
                  class="input-text"
                  v-validate="'required'"
                  name="job_title"
                  v-model="data.job_title"
                  placeholder="Cargo"
                />
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("job_title") }}</span
                >
              </div>
              <div class="contenedor-input">
                <label for="company">Empresa</label>
                <input
                  type="text"
                  class="input-text"
                  v-validate="'required'"
                  name="company"
                  v-model="data.company"
                  placeholder="Empresa"
                />
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("company") }}</span
                >
              </div>
              <div class="contenedor-input">
                <label for="email">{{ $t("formulario.emailLabel") }}</label>
                <input
                  type="text"
                  class="input-text"
                  v-validate="'required|email'"
                  name="email"
                  v-model="data.email"
                  :placeholder="$t('formulario.email') + '*'"
                />
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("email") }}</span
                >
              </div>

              <div class="contenedor-check">
                <input
                  type="checkbox"
                  v-validate="'required'"
                  name="acceptance_privacy"
                  id="acceptance_privacy"
                  v-model="data.acceptance_privacy"
                />
                <label for="acceptance_privacy"
                  >{{ $t("banner_newsletter.HeLeidoYacepto")
                  }}<router-link
                    target="_blank"
                    :to="$t('enlaces.politica_privacidad')"
                    >{{ $t("banner_newsletter.politica") }}</router-link
                  ></label
                >
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("acceptance_privacy") }}</span
                >
              </div>
              <div class="contenedor-check">
                <input
                  type="checkbox"
                  name="acceptance_legal"
                  id="acceptance_legal"
                  v-model="data.acceptance_legal"
                />

                <label for="acceptance_legal"
                  >Acepto recibir informacion y comunicaciones</label
                >
                <span
                  :class="['error', { 'animated shake': clicked }]"
                  v-if="clicked"
                  >{{ errors.first("comunicaciones") }}</span
                >
              </div>
              <button class="btn-rounded-blue">
                {{ $t("ebook.descargar") }}
              </button>
            </form>
          </template>
        </div>
      </div>
      <!-- <a href="/static/img/clientes-1.jpg" download="image-test">descarga</a>
      <a href="https://dmb_iformalia.dev.doubledot.es/private-storage/catalog/ebook/attached/attached_619d16b7d342d_imagen-iformalia.jpg?expires=1637855534&signature=2447e0dbc18dcd35f87eabcb0c080d4f4fa3ddad42b620d2f839c1da01f4dcfb" download="attached_619d16b7d342d_imagen-iformalia.jpg">descarga</a> -->
      <button
        class="btn-rounded-blue"
        @click="moreEntries"
        v-if="total != ebooks.length"
        tabindex="-1"
      >
        {{ $t("blog.cargarMas") }}
      </button>
    </section>
  </div>
</template>

<script lang="js">
import router from '@/router';
import Vue from 'vue';
import { mapGetters, mapActions } from "vuex";
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
import ebookEl from "@/components/parts/ebook-el.vue";
export default  {
  name: 'ebooks',
  props: [],
  mounted() {
    this.setData();
  },
  data() {
    return {
      textSearch: "",
      ebooks : [],
      total: null,
      actualPage: 1,
      clicked : false,
      show_form: false,
      nameEbookPopup : '',
      idEbookPopup : '',
      form_enviado:false,
      ebook_descargado:false,
      data : {
        name : '',
        job_title : '',
        company :'',
        email : '',
        acceptance_privacy : '',
        acceptance_legal : false,
        id : ''
      }

    }
  },
  methods: {
     togglePopUp: function (title,id) {
      this.show_form = !this.show_form;
      this.nameEbookPopup = title,
      this.idEbookPopup = id,
      this.data.name = '',
      this.data.job_title = '',
      this.data.company ='',
      this.data.email = '',
      this.data.acceptance_privacy = '',
      this.data.acceptance_legal = false,
      this.data.id = ''
      this.$validator.reset()
      //document.getElementById("formEbook").reset();
    },
      closePopup: function () {
      this.show_form = false,
      this.form_enviado = false,
      this.ebook_descargado = false
    },

    ...mapActions(["requestEbooks"]),
    setData() {
      let data = {
        // length: (this.actualPage == 1 ) ? 6: 6,
        length: 15,
        page: this.actualPage,
        filters: [
          {
            name: "title",
            search: this.textSearch,
            textFilter: 1,
          },
          {
            filterPack: "true",
            "filters": [
              {
                name: "tags.name",
                search: "%null_accept%",
              }
            ]
          },
        ],
      };

      this.loading = true;

      this.requestEbooks(data).then((r) => {
        this.ebooks = this.ebooks.concat(r.data);
        this.loading = false;
        this.total = r.recordsFiltered;
      });
    },
    moreEntries() {
        this.actualPage++;
        this.setData();
    },

    search(){
      this.actualPage = 1;
      this.ebooks = [];
      this.setData();
    },
        ...mapActions(['sendFormEbook', 'setLoading']),
      validateBeforeSubmit : function(){
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
            this.setLoading(true);
            this.data.id = this.idEbookPopup;
            this.sendFormEbook(this.data)
            .then(result =>{
              this.form_enviado = true;
              this.setLoading(false);
                var link = document.createElement('a');
                //console.log(link)
                link.href = result.url
                link.target = '_blank'
                link.download = result.basename;
                link.click()
            }).catch(() => {
              this.setLoading(false);
              this.ebook_descargado = true;
              //alert("ERROR")
            })
          }

        });
      },
  },
   computed: {
    ...mapGetters({
      server: "getServer",
    }),
    pages() {
      return Math.ceil(this.total / this.perpage);
    },
  },
    watch: {
    "$route.params.id"() {
      this.setData();
    },
    'textSearch'(){
      if(this.textSearch == ""){
        this.actualPage = 1;
        this.ebooks = [];
        this.setData();
      }
    }
  },
  components: {
   "ebook-el": ebookEl
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/ebooks.vue